<div class="handshakes-form">
  <div class="handshakes-form__header" ubi-dialog-title>
    {{this.data.old.name}}
  </div>
  <div class="handshakes-form__content" ubi-dialog-content>
    <form [formGroup]="crpForm">
      <div class="handshakes-form__column">
        <div class="handshakes-form__side-left">
          <div class="handshakes-form__hint">Sugggested by Handshakes</div>
          <mat-form-field class="custom-mat-form-field handshakes-form__field">
            <input matInput placeholder="Name" disabled [value]="data.old.name" autocomplete="off">
          </mat-form-field>
          <mat-form-field class="custom-mat-form-field handshakes-form__field">
            <input matInput placeholder="Identification number" disabled [value]="data.old.identificationNumber"
              autocomplete="off">
          </mat-form-field>
          <mat-form-field class="custom-mat-form-field handshakes-form__field">
            <input matInput placeholder="Nationality" disabled [value]="data.old.nationality" autocomplete="off">
          </mat-form-field>
          <mat-form-field class="custom-mat-form-field handshakes-form__field">
            <input matInput placeholder="Address" disabled [value]="data.old.address" autocomplete="off">
          </mat-form-field>
        </div>

        <div class="handshakes-form__side-right">
          <div class="handshakes-form__hint">Update the selected CRP profile</div>
          <mat-form-field class="custom-mat-form-field handshakes-form__field">
            <input matInput placeholder="Name *" aria-label="Name *" formControlName="name" autocomplete="off">
          </mat-form-field>
          <mat-form-field class="custom-mat-form-field handshakes-form__field">
            <input matInput placeholder="Identification Number *" aria-label="Identification Number *"
              formControlName="idNumber" autocomplete="off">
          </mat-form-field>
          <mat-form-field class="custom-mat-form-field handshakes-form__field">
            <input matInput placeholder="Address" formControlName="address" autocomplete="off">
          </mat-form-field>
          <div class="handshakes-form__group">
            <mat-radio-group class="custom-mat-form-field handshakes-form__group-item" formControlName="nationality"
              aria-label="Select a nationality">
              <mat-label class="handshakes-form__label">Nationality</mat-label>
              <ng-container *ngFor="let nation of data.new.nationalities; let i=index">
                <mat-radio-button class="custom-mat-radio-button" [value]="nation">
                  {{nation}}</mat-radio-button>
              </ng-container>
            </mat-radio-group>
          </div>
        </div>
        <div class="handshakes-form__group handshakes-form__group_full-width">
          <div class="handshakes-form__hint">Select roles</div>
        </div>
        <div class="handshakes-form__group handshakes-form__group_full-width">
          <div class="handshakes-form__checkbox handshakes-form__group-item" formArrayName="roles">
            <mat-label class="handshakes-form__label">Role</mat-label>
            <div *ngFor="let role of getRolesFormArray().controls; let i=index">
              <div [formGroupName]="i">
                <mat-checkbox class="custom-mat-checkbox" formControlName="isCheck">
                  {{role.value.role}}
                </mat-checkbox>
              </div>
            </div>
          </div>
          <div class="handshakes-form__checkbox handshakes-form__group-item" formArrayName="roles">
            <mat-label class="handshakes-form__label">Appointment Date</mat-label>
            <div *ngFor="let role of getRolesFormArray().controls; let i=index">
              <div [formGroupName]="i">
                <mat-checkbox [ngStyle]="{'visibility': !role.value.dateAppointed? 'hidden': 'visible'}"
                  class="custom-mat-checkbox" [checked]="role.value.isCheck && role.value.isDateCheck"
                  [disabled]="!role.value.isCheck" formControlName="isDateCheck">
                  {{role.value.dateAppointed | date:'dd/MM/yyyy'}}
                </mat-checkbox>
              </div>
            </div>
          </div>
        </div>
        <div class="handshakes-form__action">
          <button mat-button ubi-round-button class="btn btn_accent-gradient-rounded" (click)="submit()">Done</button>
        </div>
      </div>
    </form>
  </div>
</div>
